import { useEffect, useMemo } from 'react'
import { collection, limit, orderBy, query } from 'firebase/firestore'
import type { Query } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { log } from '../lib/logger'
import { ENTRY_WINDOW } from '../lib/whatsNew'
import { useFirestoreCollection } from './useFirestore'
import type { ChangelogEntry } from '../types'

/** The newest feature announcements, newest first. `enabled: false` runs no query. */
export function useChangelogEntries(enabled: boolean) {
  const entriesQuery = useMemo(
    () =>
      enabled
        ? (query(
            collection(db, 'changelogEntries'),
            orderBy('publishedAt', 'desc'),
            limit(ENTRY_WINDOW),
          ) as Query<ChangelogEntry>)
        : null,
    [enabled],
  )
  const { data, loading, error } = useFirestoreCollection<ChangelogEntry>(entriesQuery)

  useEffect(() => {
    if (error) log('whatsNew', 'failed to load changelog', { code: error.code })
  }, [error])

  return { entries: data, loading, error }
}
